import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Input, FormGroup, Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import uuid from 'react-uuid';

const EffluentDisposalItemSpecView = ({ itemTypes, itemPopupItemField, itemPopupItemSepcQ, handleItemSepcValueChange, effluentApplicationMethodList, pondSolidsSpreadInList, monthList, blockList, seperatedSolidsStoredTypeList, seperatedSolidsSpreadInList, effluentStorageTypeList
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [pondSolidsSpreadInMonthListSelectedValues, setPondSolidsSpreadInMonthListSelectedValues] = useState(itemPopupItemSepcQ.pondSolidsSpreadInMonthListSelectedValues); const [pondSolidsSpreadInMonthSelectedValues, setPondSolidsSpreadInMonthSelectedValues] = useState(itemPopupItemSepcQ.pondSolidsSpreadInMonthListSelectedValues);
    const [seperatedSolidsSpreadInMonthListSelectedValues, setSeperatedSolidsSpreadInMonthListSelectedValues] = useState(itemPopupItemSepcQ.seperatedSolidsSpreadInMonthListSelectedValues); const [seperatedSolidsSpreadInMonthSelectedValues, setSeperatedSolidsSpreadInMonthSelectedValues] = useState(itemPopupItemSepcQ.seperatedSolidsSpreadInMonthListSelectedValues);
    const [pondSolidsBlockListSelectedValues, setPondSolidsBlockListSelectedValues] = useState(itemPopupItemSepcQ.pondSolidsBlockListSelectedValues); const [pondSolidsBlockSelectedValues, setPondSolidsBlockSelectedValues] = useState(itemPopupItemSepcQ.pondSolidsBlockSelectedValues);
    const [pondSolidsSpreadIn, setPondSolidsSpreadIn] = useState(itemPopupItemSepcQ.PondSolidsSpreadIn); const [doYouSeperateSoildsPriorToEffluentEntering, setDoYouSeperateSoildsPriorToEffluentEntering] = useState(itemPopupItemSepcQ.DoYouSeperateSoildsPriorToEffluentEntering);
    const itemTypeFieldList = itemPopupItemField.itemFieldTypes;
    const itemFieldCount = itemTypeFieldList.length;
    const [seperatedSolidsSpreadIn, setSeperatedSolidsSpreadIn] = useState(itemPopupItemSepcQ.SeperatedSolidsSpreadIn);
    const [seperatedSolidsBlockListSelectedValues, setSeperatedSolidsBlockListSelectedValues] = useState(itemPopupItemSepcQ.seperatedSolidsBlockListSelectedValues); const [seperatedSolidsBlockSelectedValues, setSeperatedSolidsBlockSelectedValues] = useState(itemPopupItemSepcQ.seperatedSolidsBlockSelectedValues);
    const [isLessThan12mm, setIsLessThan12mm] = useState(itemPopupItemSepcQ.IsLessThan12mm); const [is12mmTo24mm, setIs12mmTo24mm] = useState(itemPopupItemSepcQ.Is12mmTo24mm);
    const [isGreaterThan24mm, setIsGreaterThan24mm] = useState(itemPopupItemSepcQ.IsGreaterThan24mm);
    const toggleTooltip = () => {
        setTooltipOpen(!tooltipOpen)
    };
    const [itemTypeName, setItemTypeName] = useState('');
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
        setPondSolidsSpreadInMonthListSelectedValues(itemPopupItemSepcQ.pondSolidsSpreadInMonthListSelectedValues);
    };
    useEffect(() => {
        var itemType = itemTypes.filter(x => x.id == itemPopupItemField.itemTypeId);
        setItemTypeName(itemType[0].name);
        handleHideAllDiv(itemTypeFieldList);
        if (itemType[0].name == 'Effluent Storage Pond') {
            var pondSolidsSpreadIn = pondSolidsSpreadInList.filter(x => x.id == parseInt(itemPopupItemSepcQ.PondSolidsSpreadIn));
            if (pondSolidsSpreadIn[0].name == 'Block') {
                document.getElementById('divPondSolidsSpreadIn').style.display = 'block';
            }
            else {
                document.getElementById('divPondSolidsSpreadIn').style.display = 'none';
                itemPopupItemSepcQ.pondSolidsBlockSelectedValues = '';
                itemPopupItemSepcQ.pondSolidsBlockListSelectedValues = [];
                setPondSolidsBlockListSelectedValues([]);
                setPondSolidsBlockSelectedValues('');
            }
        }
        if (itemType[0].name == 'Effluent system') {
            if (itemPopupItemSepcQ.DoYouSeperateSoildsPriorToEffluentEntering) {
                document.getElementById('divSeperateSoildsPriorToEffluentEntering').style.display = 'block';
                var seperatedSolidsSpreadIn = seperatedSolidsSpreadInList.filter(x => x.id == parseInt(itemPopupItemSepcQ.SeperatedSolidsSpreadIn));
                if (seperatedSolidsSpreadIn[0].name == 'Block') {
                    document.getElementById('divSeperatedSolidsSpreadIn').style.display = 'block';
                }
                else {
                    document.getElementById('divSeperatedSolidsSpreadIn').style.display = 'none';
                    itemPopupItemSepcQ.seperatedSolidsBlockSelectedValues = '';
                    itemPopupItemSepcQ.seperatedSolidsBlockListSelectedValues = [];
                    setSeperatedSolidsBlockListSelectedValues([]);
                    setSeperatedSolidsBlockSelectedValues('');
                }
            }
            else {
                document.getElementById('divSeperateSoildsPriorToEffluentEntering').style.display = 'none';
            }
        }
    }, [])

    const handleHideAllDiv = (itemTypeFieldList) => {
        document.querySelectorAll(".item-field").forEach(element => {
            element.style.display = 'none';
        })

        itemTypeFieldList.map(itemTypeField => {
            let className = "." + itemTypeField.className;
            document.querySelectorAll(className).forEach(element => {
                element.style.display = 'block';
            })
        })
    }

    const handlePondSolidsSpreadInMonthChange = (e) => {
        var pondSolidsSpreadInMonthSelectedValues1 = '';
        setPondSolidsSpreadInMonthSelectedValues('');
        setPondSolidsSpreadInMonthListSelectedValues(e);
        e.forEach(function (element) {
            if (pondSolidsSpreadInMonthSelectedValues1 == '') {
                pondSolidsSpreadInMonthSelectedValues1 = element.value;
            }
            else {
                pondSolidsSpreadInMonthSelectedValues1 = pondSolidsSpreadInMonthSelectedValues1 + ',' + element.value;
            }
        });
        setPondSolidsSpreadInMonthSelectedValues(pondSolidsSpreadInMonthSelectedValues1.toString());
        itemPopupItemSepcQ.pondSolidsSpreadInMonthSelectedValues = pondSolidsSpreadInMonthSelectedValues1.toString();
        itemPopupItemSepcQ.pondSolidsSpreadInMonthListSelectedValues = e;
    }

    const handleSeperatedSolidsSpreadInMonthChange = (e) => {
        var seperatedSolidsSpreadInMonthSelectedValues1 = '';
        setSeperatedSolidsSpreadInMonthSelectedValues('');
        setSeperatedSolidsSpreadInMonthListSelectedValues(e);
        e.forEach(function (element) {
            if (seperatedSolidsSpreadInMonthSelectedValues1 == '') {
                seperatedSolidsSpreadInMonthSelectedValues1 = element.value;
            }
            else {
                seperatedSolidsSpreadInMonthSelectedValues1 = seperatedSolidsSpreadInMonthSelectedValues1 + ',' + element.value;
            }
        });
        setSeperatedSolidsSpreadInMonthSelectedValues(seperatedSolidsSpreadInMonthSelectedValues1.toString());
        itemPopupItemSepcQ.seperatedSolidsSpreadInMonthSelectedValues = seperatedSolidsSpreadInMonthSelectedValues1.toString();
        itemPopupItemSepcQ.seperatedSolidsSpreadInMonthListSelectedValues = e;
    }

    const handlePondSolidsBlockChange = (e) => {
        var pondSolidsBlockSelectedValues1 = '';
        setPondSolidsBlockSelectedValues('');
        setPondSolidsBlockListSelectedValues(e);
        e.forEach(function (element) {
            if (pondSolidsBlockSelectedValues1 == '') {
                pondSolidsBlockSelectedValues1 = element.value;
            }
            else {
                pondSolidsBlockSelectedValues1 = pondSolidsBlockSelectedValues1 + ',' + element.value;
            }
        });
        setPondSolidsBlockSelectedValues(pondSolidsBlockSelectedValues1.toString());
        itemPopupItemSepcQ.pondSolidsBlockSelectedValues = pondSolidsBlockSelectedValues1.toString();
        itemPopupItemSepcQ.pondSolidsBlockListSelectedValues = e;
    }

    const handleSeperatedSolidsBlockChange = (e) => {
        var seperatedSolidsBlockSelectedValues1 = '';
        setSeperatedSolidsBlockSelectedValues('');
        setSeperatedSolidsBlockListSelectedValues(e);
        e.forEach(function (element) {
            if (seperatedSolidsBlockSelectedValues1 == '') {
                seperatedSolidsBlockSelectedValues1 = element.value;
            }
            else {
                seperatedSolidsBlockSelectedValues1 = seperatedSolidsBlockSelectedValues1 + ',' + element.value;
            }
        });
        setSeperatedSolidsBlockSelectedValues(seperatedSolidsBlockSelectedValues1.toString());
        itemPopupItemSepcQ.seperatedSolidsBlockSelectedValues = seperatedSolidsBlockSelectedValues1.toString();
        itemPopupItemSepcQ.seperatedSolidsBlockListSelectedValues = e;
    }

    const handlePondSolidsBlockValueChange = (event) => {
        const { value} = event.target;
        setPondSolidsSpreadIn(parseInt(value));
        itemPopupItemSepcQ.PondSolidsSpreadIn = value;
        var pondSolidsSpreadIn = pondSolidsSpreadInList.filter(x => x.id == parseInt(value));
        if (pondSolidsSpreadIn[0].name == 'Block') {
            document.getElementById('divPondSolidsSpreadIn').style.display = 'block';
        }
        else {
            document.getElementById('divPondSolidsSpreadIn').style.display = 'none';
            itemPopupItemSepcQ.pondSolidsBlockSelectedValues = '';
            itemPopupItemSepcQ.pondSolidsBlockListSelectedValues = [];
            setPondSolidsBlockListSelectedValues([]);
            setPondSolidsBlockSelectedValues('');
        }
    }

    const handleSeperateSoildsPriorToEffluentEnteringValueChange = (event) => {
        const { name, value, checked, type } = event.target;
        setDoYouSeperateSoildsPriorToEffluentEntering(checked);
        itemPopupItemSepcQ.DoYouSeperateSoildsPriorToEffluentEntering = checked;
        if (checked) {
            document.getElementById('divSeperateSoildsPriorToEffluentEntering').style.display = 'block';
        }
        else {
            document.getElementById('divSeperateSoildsPriorToEffluentEntering').style.display = 'none';
            itemPopupItemSepcQ.seperatedSolidsBlockSelectedValues = '';
            itemPopupItemSepcQ.seperatedSolidsBlockListSelectedValues = [];
            setSeperatedSolidsBlockListSelectedValues([]);
            setSeperatedSolidsBlockSelectedValues('');
            itemPopupItemSepcQ.seperatedSolidsSpreadInMonthSelectedValues = '';
            itemPopupItemSepcQ.seperatedSolidsSpreadInMonthListSelectedValues = [];
            setSeperatedSolidsSpreadInMonthListSelectedValues([]);
            setSeperatedSolidsSpreadInMonthSelectedValues('');
            itemPopupItemSepcQ.IsSeperatedSolidsStoredUnderCover = false;
            setSeperatedSolidsSpreadIn(0);
        }
    }

    const handleSeperatedSolidsSpreadInBlockValueChange = (event) => {
        const { value } = event.target;
        setSeperatedSolidsSpreadIn(parseInt(value));
        itemPopupItemSepcQ.SeperatedSolidsSpreadIn = value;
        var seperatedSolidsSpreadIn = seperatedSolidsSpreadInList.filter(x => x.id == parseInt(value));
        if (seperatedSolidsSpreadIn[0].name == 'Block') {
            document.getElementById('divSeperatedSolidsSpreadIn').style.display = 'block';
        }
        else {
            document.getElementById('divSeperatedSolidsSpreadIn').style.display = 'none';
            itemPopupItemSepcQ.seperatedSolidsBlockSelectedValues = '';
            itemPopupItemSepcQ.seperatedSolidsBlockListSelectedValues = [];
            setSeperatedSolidsBlockListSelectedValues([]);
            setSeperatedSolidsBlockSelectedValues('');
        }
    }

    const handleActualEffluentApplicationDepthValueChange = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'IsLessThan12mm') {
            if (value) {
                setIsLessThan12mm(checked);
                setIs12mmTo24mm(false);
                setIsGreaterThan24mm(false);
                itemPopupItemSepcQ.IsLessThan12mm = checked;
                itemPopupItemSepcQ.Is12mmTo24mm = false;
                itemPopupItemSepcQ.IsGreaterThan24mm = false;
            }
            else {
                setIsLessThan12mm(checked);
                itemPopupItemSepcQ.IsLessThan12mm = checked;
            }
        }
        else if (name == 'Is12mmTo24mm') {
            if (value) {
                setIsLessThan12mm(false);
                setIs12mmTo24mm(checked);
                setIsGreaterThan24mm(false);
                itemPopupItemSepcQ.IsLessThan12mm = false;
                itemPopupItemSepcQ.Is12mmTo24mm = checked;
                itemPopupItemSepcQ.IsGreaterThan24mm = false;
            }
            else {
                setIs12mmTo24mm(checked);
                itemPopupItemSepcQ.Is12mmTo24mm = checked;
            }
        }
        else if (name == 'IsGreaterThan24mm') {
            if (value) {
                setIsLessThan12mm(false);
                setIs12mmTo24mm(false);
                setIsGreaterThan24mm(checked);
                itemPopupItemSepcQ.IsLessThan12mm = false;
                itemPopupItemSepcQ.Is12mmTo24mm = false;
                itemPopupItemSepcQ.IsGreaterThan24mm = checked;
            }
            else {
                setIsGreaterThan24mm(checked);
                itemPopupItemSepcQ.IsGreaterThan24mm = checked;
            }
        }
    }

    if (itemFieldCount > 0) {
        return (
            <>
                <Card>
                    <CardHeader onClick={toggle}>
                        <Row>
                            <Col sm="11">
                                <h6>Additional Information</h6>
                            </Col>
                            <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Collapse isOpen={isOpen}>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col sm="3">
                                            <Label className='item-field spray-from-sump'>Effluent System (please tick)</Label>
                                        </Col>
                                        <Col sm="9">
                                            <Row style={{ marginBottom: `-1rem !important` }}>
                                                <Col>
                                                    <FormGroup className='item-field spray-from-sump' >
                                                        <Input className="form-check-input" type="checkbox" checked={itemPopupItemSepcQ.IsSprayFromSump} onChange={handleItemSepcValueChange} name="IsSprayFromSump" id="IsSprayFromSump" />
                                                        <Label style={{ marginLeft: "10px" }}>Spray from Sump</Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col>
                                                    <FormGroup className='item-field holding-pond'>
                                                        <Input className="form-check-input" type="checkbox" checked={itemPopupItemSepcQ.IsHoldingPond} onChange={handleItemSepcValueChange} name="IsHoldingPond" id="IsHoldingPond" />
                                                        <Label style={{ marginLeft: "10px" }}>Holding Pond</Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginBottom: `-1rem !important` }}>
                                                <Col>
                                                    <FormGroup className='item-field exported-off-farm'>
                                                        <Input className="form-check-input" type="checkbox" checked={itemPopupItemSepcQ.IsExportedOffFarm} onChange={handleItemSepcValueChange} name="IsExportedOffFarm" id="IsExportedOffFarm" />
                                                        <Label style={{ marginLeft: "10px" }}>Exported off Farm</Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col>
                                                    <FormGroup className='item-field effluent-system-other'>
                                                        <Input className="form-check-input" type="checkbox" checked={itemPopupItemSepcQ.IsEffluentSystemOther} onChange={handleItemSepcValueChange} name="IsEffluentSystemOther" id="IsEffluentSystemOther" />
                                                        <Label style={{ marginLeft: "10px" }}>Other</Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col sm="3">
                                            <Label className='item-field less-than-twelvemm'>Actual Effluent Application Depth -(mm) (please tick)</Label>
                                        </Col>
                                        <Col sm="9">
                                            <Row style={{ marginBottom: `-1rem !important` }}>
                                                <Col>
                                                    <FormGroup className='item-field less-than-twelvemm' style={{ marginBottom: "0rem !important" }}>
                                                        <Input className="form-check-input" type="checkbox" checked={isLessThan12mm} onChange={handleActualEffluentApplicationDepthValueChange} name="IsLessThan12mm" id="IsLessThan12mm" />
                                                        <Label style={{ marginLeft: "10px" }}>&#60; 12mm</Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col>
                                                    <FormGroup className='item-field twelvemm-to-twentyfourmm' style={{ marginBottom: "0rem !important" }}>
                                                        <Input className="form-check-input" type="checkbox" checked={is12mmTo24mm} onChange={handleActualEffluentApplicationDepthValueChange} name="Is12mmTo24mm" id="Is12mmTo24mm" />
                                                        <Label style={{ marginLeft: "10px" }}>12-24mm</Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col>
                                                    <FormGroup className='item-field greater-than-twentyfourmm' style={{ marginBottom: "0rem !important" }}>
                                                        <Input className="form-check-input" type="checkbox" checked={isGreaterThan24mm} onChange={handleActualEffluentApplicationDepthValueChange} name="IsGreaterThan24mm" id="IsGreaterThan24mm" />
                                                        <Label style={{ marginLeft: "10px" }}>&#62; 24mm</Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row >
                                <Col sm="6" className='item-field days-of-effluent-storage'>
                                    <FormGroup>
                                        <Label>Storage Volume (L)</Label>
                                        <Input onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }} type="number" name="DaysOfEffluentStorage" id="DaysOfEffluentStorage" value={itemPopupItemSepcQ.DaysOfEffluentStorage} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="6" className='item-field effluent-storage-type'>
                                    <FormGroup>
                                        <Label>Type</Label>
                                        <Input type="select" onChange={handleItemSepcValueChange} name="EffluentStorageType" id="EffluentStorageType" value={itemPopupItemSepcQ.EffluentStorageType} >
                                            {effluentStorageTypeList != undefined && effluentStorageTypeList.map(Option =>
                                                <option key={uuid()} value={Option.id}>{Option.name}</option>
                                            )}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm="6" className='item-field effluent-application-method'>
                                    <FormGroup>
                                        <Label>Effluent Application Method</Label>
                                        <Input type="select" onChange={handleItemSepcValueChange} name="EffluentApplicationMethod" id="EffluentApplicationMethod" value={itemPopupItemSepcQ.EffluentApplicationMethod} >
                                            {effluentApplicationMethodList != undefined && effluentApplicationMethodList.map(Option =>
                                                <option key={uuid()} value={Option.id}>{Option.name}</option>
                                            )}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm="6" className='item-field effluent-pond-have-stirrer'>
                                    <FormGroup>
                                        <Label>{itemTypeName == 'Effluent Storage Pond' ? 'Does it have a stirrer' : 'Does the effluent pond have a stirrer'}</Label><br />
                                        <input className="form-check-input" name="IsEffluentPondHaveStirrer" type="checkbox" checked={itemPopupItemSepcQ.IsEffluentPondHaveStirrer} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6" className='item-field the-pond-soilds-spread-on'>
                                    <FormGroup>
                                        <Label>Are the pond solids spread on Land Units, crops or exported</Label>
                                        <Input type="select" onChange={handlePondSolidsBlockValueChange} name="PondSolidsSpreadIn" id="PondSolidsSpreadIn" value={pondSolidsSpreadIn} >
                                            {pondSolidsSpreadInList != undefined && pondSolidsSpreadInList.map(Option =>
                                                <option key={uuid()}  value={Option.id}>{Option.name}</option>
                                            )}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm="6" id="divPondSolidsSpreadIn" style={{ display: `none` }}>
                                    <FormGroup>
                                        <Label>Land Units</Label>
                                        <Select className="dropdown" placeholder="Select Option" value={pondSolidsBlockListSelectedValues} options={blockList} onChange={handlePondSolidsBlockChange} isMulti isClearable />
                                    </FormGroup>
                                </Col>
                                <Col sm="6" className='item-field how-often-pond-solids-are-removed'>
                                    <FormGroup>
                                        <Label>How Often Pond Solids Are Removed</Label>
                                        <Input type="text" name="HowOftenPondSoildsRemoved" id="HowOftenPondSoildsRemoved" value={itemPopupItemSepcQ.HowOftenPondSoildsRemoved} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="6" className='item-field were-pond-solids-removed'>
                                    <FormGroup>
                                        <Label>Were pond solids removed and spread</Label><br />
                                        <input className="form-check-input" name="WerePondSoildsRemovedAndSpread" type="checkbox" checked={itemPopupItemSepcQ.WerePondSoildsRemovedAndSpread} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="6" className='item-field what-month-are-pond-solids-spread-in'>
                                    <FormGroup>
                                        <Label>What month/s are pond solids spread in</Label>
                                        <Select className="dropdown" placeholder="Select Option" value={pondSolidsSpreadInMonthListSelectedValues} options={monthList} onChange={handlePondSolidsSpreadInMonthChange} isMulti isClearable />
                                    </FormGroup>
                                </Col>
                                <Col sm="6" className='item-field do-you-seperate-solids-prior-to-effluent-entering'>
                                    <FormGroup>
                                        <Label>Do you separate solids prior to effluent entering effluent system</Label><br />
                                        <input className="form-check-input" name="DoYouSeperateSoildsPriorToEffluentEntering" type="checkbox" checked={doYouSeperateSoildsPriorToEffluentEntering} onChange={handleSeperateSoildsPriorToEffluentEnteringValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div id="divSeperateSoildsPriorToEffluentEntering" style={{ display: `none` }}>
                                <Row >
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label>Are the separated solids spread on land units, crops or exported</Label>
                                            <Input type="select" onChange={handleSeperatedSolidsSpreadInBlockValueChange} name="SeperatedSolidsSpreadIn" id="SeperatedSolidsSpreadIn" value={seperatedSolidsSpreadIn} >
                                                {seperatedSolidsSpreadInList != undefined && seperatedSolidsSpreadInList.map(Option =>
                                                    <option key={uuid()} value={Option.id}>{Option.name}</option>
                                                )}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <div id="divSeperatedSolidsSpreadIn" style={{ display: `none` }}>
                                            <FormGroup>
                                                <Label>Land Units</Label>
                                                <Select className="dropdown" placeholder="Select Option" value={seperatedSolidsBlockListSelectedValues} options={blockList} onChange={handleSeperatedSolidsBlockChange} isMulti isClearable />
                                            </FormGroup>
                                        </div>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label>Does the effluent pond have a stirrer</Label><br />
                                            <input className="form-check-input" name="IsSeperatedSolidsStoredUnderCover" type="checkbox" checked={itemPopupItemSepcQ.IsSeperatedSolidsStoredUnderCover} onChange={handleItemSepcValueChange} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label>What month/s are seperated solids spread in</Label>
                                            <Select className="dropdown" placeholder="Select Option" value={seperatedSolidsSpreadInMonthListSelectedValues} options={monthList} onChange={handleSeperatedSolidsSpreadInMonthChange} isMulti isClearable />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col sm="6">
                                    <FormGroup className='item-field are-the-separated-solids-stored-under-cover'>
                                        <Label>Are the separated solids stored under cover or open to rain</Label>
                                        <Input type="select" onChange={handleItemSepcValueChange} name="SeperatedSolidsStoredType" id="SeperatedSolidsStoredType" value={itemPopupItemSepcQ.SeperatedSolidsStoredType} >
                                            {seperatedSolidsStoredTypeList != undefined && seperatedSolidsStoredTypeList.map(Option =>
                                                <option value={Option.id}>{Option.name}</option>
                                            )}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup className='item-field spray-irrigator-type'>
                                        <Label>Spray Irrigator Type</Label>
                                        <Input type="text" name="SprayIrrigatorType" id="SprayIrrigatorType" value={itemPopupItemSepcQ.SprayIrrigatorType} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row >
                                <Col sm="6">
                                    <FormGroup className='item-field has-effluent-storage-pond-been-leak-tested'>
                                        <Label>Has the effluent storage pond been leak tested?</Label>
                                        <Input type="select" onChange={handleItemSepcValueChange} name="HasEffluentStoragePondDamBeenLeakTested" id="HasEffluentStoragePondDamBeenLeakTested" value={itemPopupItemSepcQ.HasEffluentStoragePondDamBeenLeakTested}>
                                            <option value={0} >Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                {itemPopupItemSepcQ.HasEffluentStoragePondDamBeenLeakTested == 'Yes' &&
                                    <Col sm="6">
                                        <FormGroup className='item-field leak-testing-detail-outcome-effluent'>
                                            <Label>Leak testing detail and outcome</Label>
                                            <Input type="textarea" name="LeakTestingDetailOutcome" id="LeakTestingDetailOutcome" value={itemPopupItemSepcQ.LeakTestingDetailOutcome} onChange={handleItemSepcValueChange} />
                                        </FormGroup>
                                    </Col>
                                }
                            </Row>
                        </Collapse>
                    </CardBody>
                </Card>
                <br />
            </>
        )
    }

}
export default EffluentDisposalItemSpecView